import { render, staticRenderFns } from "./bankStatement.vue?vue&type=template&id=55ff35c5&scoped=true&"
import script from "./bankStatement.vue?vue&type=script&lang=js&"
export * from "./bankStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff35c5",
  null
  
)

export default component.exports